import React, { useContext, useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ActionComponent } from './ActionComponent';
// eslint-disable-next-line import/no-cycle
import { Context } from './ContextWrapper';
import * as action from '../Store/SystemMasters.action';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';

function CardItem({ index, item: cardDetails }) {
  const { _id, name, isActive } = cardDetails;
  const { updateArray, removeFromArray, formState, setFormValues, setFormState, MasterDeleteAccess, MasterAddEditAccess } = useContext(Context);
  const {
    UserDetails: { userInfo },
  } = useSelector((state) => state);
  const genId = _id || `_id${index}`;
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [shouldShowDelete, setShouldShowDelete] = useState(true);
  const [shouldShowConfirmation, setShouldShowConfirmation] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!Object.keys(formState?.values)?.includes(_id)) {
      setFormValues(name, _id);
    }
  }, [_id, name, formState]);

  useEffect(() => {
    if (genId.includes('_id')) {
      setShouldShowDelete(false);
      setShouldShowConfirmation(false);
    } else {
      setShouldShowConfirmation(true);
      setShouldShowDelete(true);
    }
  }, [genId]);

  const handleBlur = (e) => {
    const { value } = e.target;
    updateArray({ name: value }, genId);
  };

  const handleDelete = useCallback(async () => {
    try {
      if (genId?.includes('_id')) {
        removeFromArray(genId);

        setFormValues('', genId);
        return null;
      }

      setIsLoading(true);
      const req = { section: 'masters', module: 'productGroups', action: 'delete' };
      await dispatch(action.deleteProductGroup(genId, t, req));
      await dispatch(action.fetchProductGroup({ loggedInUserId: userInfo.userId }, t));
      setIsLoading(false);
      setShowDelete((prev) => !prev);
    } catch (error) {}
  }, [dispatch, genId, removeFromArray, setFormValues, t, userInfo.userId, setFormState]);

  const handleActiveInactive = useCallback(async () => {
    try {
      if (genId?.includes('_id')) {
        return null;
      }
      const obj = {
        ...cardDetails,
        isActive: !isActive,
        title: t('CARD_ITEMS.PRODUCT_GROUP_MASTER'),
        loggedInUserId: userInfo.userId,
        section: 'masters',
        module: 'productGroups',
        action: 'addEdit',
      };
      setIsLoading(true);
      await dispatch(action.setActiveInactive(obj, t));
      await dispatch(action.fetchProductGroup(t));

      setIsLoading(false);
      setShowConfirmation((prev) => !prev);
    } catch (error) {}
  }, [cardDetails, dispatch, genId, isActive, t, userInfo.userId]);

  const deleteAction = shouldShowDelete ? () => setShowDelete((prev) => !prev) : handleDelete;
  const activeAction = () => setShowConfirmation((prev) => !prev);

  return (
    <>
      <div className="list-container">
        <li>
          <div className="input-container">
            <div className="d-flex">
              <input
                key={index}
                name={genId}
                value={formState?.values?.[genId]}
                onChange={(e) => {
                  const inputValue = e.target.value.trimStart().slice(0, 50);
                  setFormValues(inputValue, e.target.name);
                }}
                placeholder={t('CARD_ITEMS.ENTER_PRODUCT_GROUP')}
                type="text"
                onBlur={handleBlur}
                disabled={!MasterAddEditAccess}
                autoFocus={_id?.includes('_id')}
              />
            </div>
            {formState.isSubmitted && <p className="text-danger m-0 p-1">{formState.errors?.[genId]}</p>}
          </div>

          <div className="input-action">
            <ActionComponent
              deleteAction={deleteAction}
              activeAction={activeAction}
              showActiveBtn={shouldShowConfirmation}
              isActive={isActive}
              MasterDeleteAccess={MasterDeleteAccess}
              MasterAddEditAccess={MasterAddEditAccess}
            />
          </div>
        </li>
      </div>

      {shouldShowDelete && (
        <ConfirmationPopup
          onOpen={showDelete}
          onConfirm={() => handleDelete()}
          title={t('CARD_ITEMS.DELETE_FROM_SYSTEM_MASTER')}
          message={t('CARD_ITEMS.ARE_YOU_SURE_DELETE_ITEM')}
          toggle={() => {
            setShowDelete((prev) => !prev);
          }}
          loading={isLoading}
        />
      )}

      <ConfirmationPopup
        onOpen={showConfirmation}
        onConfirm={() => handleActiveInactive()}
        title={t('CARD_ITEMS.ACTIVATE_DEACTIVATE')}
        message={t('CARD_ITEMS.ARE_YOU_SURE_ACTIVE_DEACTIVATE')}
        toggle={() => {
          setShowConfirmation((prev) => !prev);
        }}
        loading={isLoading}
      />
    </>
  );
}

export default CardItem;
